import { gql } from '@apollo/client';

export const DELETE_SURROUNDING_INFORMATION_PROPERTY_MUTATION = gql`
  mutation DeleteSurroundingInformationProperty($id: ID!) {
    deleteSurroundingInformationProperty(input: { where: { id: $id } }) {
      surroundingInformationProperty {
        id
      }
    }
  }
`;
